module.exports = __webpack_public_path__ + "img/gigastore-lp-pos.51477e70.png";